import { gql } from '@apollo/client'

export const CREATE_COMPLIANCE_EXEMPTION = gql`
  mutation CreateComplianceExemption($input: CreateComplianceExemptionInput!) {
    createComplianceExemption(input: $input) {
      exemption {
        patientId
        reason
        categories
        detail
        createdAt
        updatedAt
      }
    }
  }
`

export const UPDATE_COMPLIANCE_EXEMPTION = gql`
  mutation UpdateComplianceExemption($input: UpdateComplianceExemptionInput!) {
    updateComplianceExemption(input: $input) {
      exemption {
        patientId
        reason
        categories
        detail
        createdAt
        updatedAt
      }
    }
  }
`

export const DELETE_COMPLIANCE_EXEMPTION = gql`
  mutation DeleteComplianceExemption($patientId: ID!) {
    deleteComplianceExemption(patientId: $patientId) {
      patientId
    }
  }
`
